import { SemanaItens } from '../../Interfaces/shared/semanaItens';

export const Semana: SemanaItens[] = [
  { id: 1, dia: 'Domingo' },
  { id: 2, dia: 'Segunda-feira' },
  { id: 3, dia: 'Terça-feira' },
  { id: 4, dia: 'Quarta-feira' },
  { id: 5, dia: 'Quinta-feira' },
  { id: 6, dia: 'Sexta-feira' },
  { id: 7, dia: 'Sábado' }
];

export const UrlBuscarCliente = "UsuarioCliente";